export const RELATIONSHIP_TYPES = [
  'Mother',
  'Father',
  'Spouse',
  'Legal guardian',
  'Sister',
  'Brother',
  'Daughter',
  'Son',
  'Partner/significent other',
  'Relative (other)',
  'Grandfather',
  'Grandmother',
  'Aunt',
  'Uncle',
  'Friend',
  'Acquaintance',
  'Ex-spouse/partner',
];
